var map = {
	"./Box_alt.svg": "./src/assets/Box_alt.svg",
	"./DC_Claims_Insights.svg": "./src/assets/DC_Claims_Insights.svg",
	"./Direct_club_delivery_tracking.svg": "./src/assets/Direct_club_delivery_tracking.svg",
	"./Drop_&_Hook.svg": "./src/assets/Drop_&_Hook.svg",
	"./FC_Inbound_KPI_tracking.svg": "./src/assets/FC_Inbound_KPI_tracking.svg",
	"./Icon.svg": "./src/assets/Icon.svg",
	"./Inbound_Collect_Transportation.svg": "./src/assets/Inbound_Collect_Transportation.svg",
	"./Inbound_KPIs.svg": "./src/assets/Inbound_KPIs.svg",
	"./OCL_summary.svg": "./src/assets/OCL_summary.svg",
	"./Outbound_KPIs.svg": "./src/assets/Outbound_KPIs.svg",
	"./Packman_Adoption.svg": "./src/assets/Packman_Adoption.svg",
	"./STEEL_ETA_accuracy.svg": "./src/assets/STEEL_ETA_accuracy.svg",
	"./VisionText copy.svg": "./src/assets/VisionText copy.svg",
	"./VisionText.svg": "./src/assets/VisionText.svg",
	"./Voice_of_the_Nation.svg": "./src/assets/Voice_of_the_Nation.svg",
	"./back_action.svg": "./src/assets/back_action.svg",
	"./beacon.svg": "./src/assets/beacon.svg",
	"./calender-backward.svg": "./src/assets/calender-backward.svg",
	"./calender-forward.svg": "./src/assets/calender-forward.svg",
	"./calender-icon.svg": "./src/assets/calender-icon.svg",
	"./cart.svg": "./src/assets/cart.svg",
	"./center-point.svg": "./src/assets/center-point.svg",
	"./document.svg": "./src/assets/document.svg",
	"./etaSkuCount.svg": "./src/assets/etaSkuCount.svg",
	"./event.svg": "./src/assets/event.svg",
	"./fc_inbound.svg": "./src/assets/fc_inbound.svg",
	"./fcsSkuCount.svg": "./src/assets/fcsSkuCount.svg",
	"./importsSkuCount.svg": "./src/assets/importsSkuCount.svg",
	"./insight_chat.svg": "./src/assets/insight_chat.svg",
	"./leave_feedback.svg": "./src/assets/leave_feedback.svg",
	"./messaging_warning.svg": "./src/assets/messaging_warning.svg",
	"./ob_carrier_communication.svg": "./src/assets/ob_carrier_communication.svg",
	"./perishableDCsSkuCount.svg": "./src/assets/perishableDCsSkuCount.svg",
	"./report_issue.svg": "./src/assets/report_issue.svg",
	"./reportsstack.svg": "./src/assets/reportsstack.svg",
	"./skuCount.svg": "./src/assets/skuCount.svg",
	"./track-trace-nav.svg": "./src/assets/track-trace-nav.svg",
	"./tracker.svg": "./src/assets/tracker.svg",
	"./warning.svg": "./src/assets/warning.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*\\.svg$";